import { defineStyleConfig } from '@chakra-ui/styled-system'

export const closeButtonTheme = defineStyleConfig({
  defaultProps: {
    size: 'sm',
  },
})
